import { useState } from "react";
import JSZip from "jszip";
import { toast } from "sonner";
import { Images } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { loadImage, toBlob } from "./InstagramPost";

async function fullSizeJpg(src) {
  const img = await loadImage(imgUrl(src));
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  canvas.getContext("2d").drawImage(img, 0, 0);
  return toBlob(canvas);
}

export function DownloadPhotosButton({ vehicle }) {
  const [busy, setBusy] = useState(false);
  const photos = vehicle.images || [];
  const download = async () => {
    setBusy(true);
    try {
      const zip = new JSZip();
      for (let i = 0; i < photos.length; i += 1) {
        zip.file(`${vehicle.slug}-${String(i + 1).padStart(2, "0")}.jpg`, await fullSizeJpg(photos[i]));
      }
      const a = document.createElement("a");
      a.href = URL.createObjectURL(await zip.generateAsync({ type: "blob" }));
      a.download = `${vehicle.slug}-photos.zip`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
      toast.success(`Downloaded ${photos.length} photos`);
    } catch {
      toast.error("Could not download the photos. Please try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={download} disabled={busy || !photos.length} aria-label="Download all photos" title="Download all photos" data-testid={`download-photos-${vehicle.slug}`} className="disabled:opacity-40">
      <Images className="h-4 w-4" />
    </button>
  );
}
